<template>
  <div id="login">
    <b>ログイン画面</b><br/><br/>

    <table>
      <tr>
        <td>３６０評価システム</td>
      </tr>
    </table><br/>

    <font color="red">勤怠システムのユーザＩＤとパスワードを利用してログインしてください。</font><br/><br/>

    <div v-if="this.$router.currentRoute.name == 'login2' ">
    代理先：<input type="text" placeholder="ユーザＩＤ" v-model="asMemberID">
    </div>
    ユーザＩＤ：<input type="text" placeholder="ユーザＩＤ" v-model="memberID"><br/>
    パスワード：<input type="password" placeholder="パスワード" v-model="password"><br/>
    <br/>
    <button id="loginBtn" v-on:click="signinClick" class="btn-mid" style="width:120px;">ログイン</button><br/>

  </div>
</template>

<script>
  export default {
    name: "login",
    data() {
      return {
          memberID: '',
          password: '',
          asMemberID: ''
      }
    },
    methods: {
      signinClick: function () {
        var self = this;
        $("#loginBtn").attr("disabled", true);
        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = { memberID: self.memberID, password: self.password ,asMemberID:self.asMemberID};
          axios.post(process.env.API_URL +"/api/LoginSignin", data)
            .then(function (res) {
              $("#loginBtn").attr("disabled", false);
              // 処理正常の場合
              if (res.data.message == '') {
                self.$router.push({ name: 'mains', params: { } });
                sessionStorage.setItem(common.TOKEN_KEY,res.data.token);
              }
              // 処理エラーの場合
              else {
                alert(res.data.message);
              }
            })
            .catch(function (err) {
              alert(err);
              $("#loginBtn").attr("disabled", false);
            });
        });
      },

    }
  };
</script>



// WEBPACK FOOTER //
// login.vue?7769a3af